// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"c0ebf5cc","7272":"c0ebf5cc","8882":"c0ebf5cc","9007":"be221ba9"}[chunkId] + ".chunk.css";
};